module.exports = __webpack_public_path__ + "img/dang6.978aca44.png";